export default (val) => {
  if (!val) {
    return '';
  }
  const value = val.toString();
  return value.toLowerCase();
};



// WEBPACK FOOTER //
// ./src/filter/lowercase.js